import { QueryObserverOptions, useQuery } from '@tanstack/react-query'
import { AuthService } from '../../lib/api'
import { GetAuthMeResponseData } from '../../lib/api/types/auth.interfaces'

export const useAuthMe = (
	options?: Partial<QueryObserverOptions<GetAuthMeResponseData>>,
) => {
	return useQuery<GetAuthMeResponseData>({
		queryKey: ['auth', 'me'],
		queryFn: () => AuthService.getMe(),
		retry: false,
		...options,
	})
}
